module.exports = __webpack_public_path__ + "media/images/link-94119ae2.svg";